<!--  -->
<template>
  <div class="referral">
    <div class="referral-menu">
      <!-- 导航 -->
      <menu-row :menuList="menuList"></menu-row>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
// less
import './other.less'
// components
import MenuRow from '_c/menu-row/menu-row'
export default {
  name: 'referral',
  components: {
    MenuRow
  },
  data () {
    return {
      menuList: [
        {
          title: 'Paying mentee',
          name: ['referral-pay']
        },
        {
          title: 'Scholarship mentee',
          name: ['referral-scholarship']
        }
      ]
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
